"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_OBJ = exports.EMPTY_ARRAY = exports.APP_DEEP_LINK_URLS = exports.APP_DEEP_LINK_SCHEMA = exports.DEVHUB_LINKS = exports.GRAPHQL_ENDPOINT = exports.DEVHUB_BETA_URL = exports.APP_BASE_URL = exports.GOOGLEPLAY_ID = exports.APPSTORE_ID = exports.API_BASE_URL = exports.SHOW_GITHUB_PERSONAL_TOKEN_LOGIN_BUTTON = exports.SHOW_GITHUB_FULL_ACCESS_LOGIN_BUTTON = exports.GITHUB_APP_HAS_CODE_ACCESS = exports.FULL_ACCESS_GITHUB_OAUTH_SCOPES = exports.DEFAULT_GITHUB_OAUTH_SCOPES = exports.DEFAULT_THEME_PAIR = exports.DEFAULT_LIGHT_THEME = exports.DEFAULT_DARK_THEME = exports.DISABLE_SWIPEABLE_CARDS = exports.DISABLE_ANIMATIONS = exports.MAX_COLUMN_WIDTH = exports.MIN_COLUMN_WIDTH = exports.COLUMNS_LIMIT = exports.IS_BETA = exports.HOSTNAME = exports.APP_VERSION = void 0;
const pkg = require('../../package.json'); // tslint:disable-line
exports.APP_VERSION = `${pkg.version || ''}`.replace(/\-\d+$/g, '');
const _window = typeof window !== 'undefined' ? window : undefined;
exports.HOSTNAME = _window &&
    _window.location &&
    _window.location.hostname &&
    _window.location.hostname;
exports.IS_BETA = exports.APP_VERSION.includes('beta') || (!!exports.HOSTNAME && exports.HOSTNAME.includes('beta'));
exports.COLUMNS_LIMIT = 25;
exports.MIN_COLUMN_WIDTH = 300;
exports.MAX_COLUMN_WIDTH = 340;
exports.DISABLE_ANIMATIONS = false;
exports.DISABLE_SWIPEABLE_CARDS = false;
exports.DEFAULT_DARK_THEME = 'dark-blue';
exports.DEFAULT_LIGHT_THEME = 'light-blue';
exports.DEFAULT_THEME_PAIR = {
    id: 'dark-gray',
    color: '',
};
exports.DEFAULT_GITHUB_OAUTH_SCOPES = ['notifications', 'user:email'];
exports.FULL_ACCESS_GITHUB_OAUTH_SCOPES = [
    ...exports.DEFAULT_GITHUB_OAUTH_SCOPES,
    'repo',
];
exports.GITHUB_APP_HAS_CODE_ACCESS = true;
exports.SHOW_GITHUB_FULL_ACCESS_LOGIN_BUTTON = false;
exports.SHOW_GITHUB_PERSONAL_TOKEN_LOGIN_BUTTON = true;
exports.API_BASE_URL = 'https://lazico.vn';
exports.APPSTORE_ID = '1579294803';
exports.GOOGLEPLAY_ID = 'com.lazico.data';
exports.APP_BASE_URL = 'https://lazico-connect.web.app/';
exports.DEVHUB_BETA_URL = 'https://lazico-devices.web.app';
exports.GRAPHQL_ENDPOINT = `${exports.API_BASE_URL}/graphql`;
const LANDING_BASE_URL = 'https://lazico.com';
exports.DEVHUB_LINKS = {
    LANDING_PAGE_HOME: LANDING_BASE_URL,
    ACCOUNT_PAGE: `${LANDING_BASE_URL}/account`,
    DOWNLOAD_PAGE: `${LANDING_BASE_URL}/download`,
    PRICING_PAGE: `${LANDING_BASE_URL}/pricing`,
    SUBSCRIBE_PAGE: `${LANDING_BASE_URL}/subscribe`,
    SLACK_INVITATION: 'https://slack.lazico.com',
    GITHUB_REPOSITORY: 'https://github.com/lazico/lazico',
    TWITTER_PROFILE: 'https://twitter.com/lazico',
};
exports.APP_DEEP_LINK_SCHEMA = 'lazico';
exports.APP_DEEP_LINK_URLS = {
    github_oauth: `${exports.APP_DEEP_LINK_SCHEMA}://github/oauth`,
    preferences: `${exports.APP_DEEP_LINK_SCHEMA}://preferences`,
    pricing: `${exports.APP_DEEP_LINK_SCHEMA}://pricing`,
    redux: `${exports.APP_DEEP_LINK_SCHEMA}://redux`,
    subscribe: `${exports.APP_DEEP_LINK_SCHEMA}://purchase`,
};
// prettier-ignore
exports.EMPTY_ARRAY = [];
// prettier-ignore
exports.EMPTY_OBJ = {};
//# sourceMappingURL=constants.js.map